export default "__VITE_ASSET__3ec7eeb6__"